import {
  FETCH_USER_ROLES, FETCH_USER_ROLES_SUCCEEDED, FETCH_USER_ROLES_FAILED,
  CREATE_USER_ROLE, CREATING_USER_ROLE_SUCCEEDED, CREATING_USER_ROLE_FAILED,
  UPDATE_USER_ROLE, UPDATING_USER_ROLE_SUCCEEDED, UPDATING_USER_ROLE_FAILED,
  DELETE_USER_ROLE, DELETING_USER_ROLE_SUCCEEDED, DELETING_USER_ROLE_FAILED
} from 'constants/actionTypes.jsx';


const initialState = {
  loading: false,
  items: [],
  userRole: {
    item: null,
    loading: false,
    creating: false,
    updating: false
  }
}

function userRolesReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_USER_ROLE: 
    return {
      ...state,
      creating: true
    }
  
  case CREATING_USER_ROLE_SUCCEEDED: 

    var items = state.items
    return {
      ...state,
      creating: false,
      items: [...state.items, action.payload],
      storyboard: {
        ...state.storyboard,
        item: action.payload
      }
    }

  case CREATING_USER_ROLE_FAILED: 
    return {
      ...state,
      creating: false,
      error: action.payload
    }

  case UPDATE_USER_ROLE: 
    return {
      ...state,
      storyboard: {
        ...state.storyboard,
        updating: true
      }
    }

  case UPDATING_USER_ROLE_SUCCEEDED: 
    return {
      ...state,
      storyboard: {
        ...state.storyboard,
        updating: false,
        item: action.payload
      }
    }

  case UPDATING_USER_ROLE_FAILED:
    return {
      ...state,
      storyboard: {
        ...state.storyboard,
        updating: false,
        error: action.payload
      }
    }


  case DELETE_USER_ROLE: 
    return {
      ...state,
      storyboard: {
        ...state.storyboard,
        deleting: true
      }
    }

  case DELETING_USER_ROLE_SUCCEEDED: 
    var items = state.items.filter(item => {
      return item.id !== action.payload;
    })
    
    return {
      ...state,
      items: items,
      storyboard: {
        ...state.storyboard,
        deleting: false,
        item: null
      }
    }

  case DELETING_USER_ROLE_FAILED: 
    return {
      ...state,
      storyboard: {
        ...state.storyboard,
        deleting:  false,
        error: action.payload.error
      }
    }


    case FETCH_USER_ROLES:
      return  {
        ...state,
        loading: true
      }

    case FETCH_USER_ROLES_SUCCEEDED:
      var records = action.payload;

      return{
        ...state,
        loading: false,
        items: records
      }

      case FETCH_USER_ROLES_FAILED:
        return{
          ...state,
          loading: false,
          items: [],
          error: action.payload
        }

    default:
      return state
  }
}

export { userRolesReducer };